import { render, staticRenderFns } from "./SearchOrderTypeSelect.vue?vue&type=template&id=0bd77a1c"
import script from "./SearchOrderTypeSelect.vue?vue&type=script&lang=js"
export * from "./SearchOrderTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports